if (!customElements.get('fd-wish-popup')) {
  customElements.define('fd-wish-popup', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.tab = this.querySelector('[data-wish-open]');
      this.form = this.querySelector('form');
      this.key = '2d-wish-v1';
      this.sessionKey = '2d-wish-session-v1';
      this.ready = this.dataset.ready === 'true';
      this.preview = new URLSearchParams(location.search).get('wish_preview') === '1';
      this.editor = !!window.Shopify?.designMode;
      this.excluded = ['cart', 'password'].includes(this.dataset.page) || /\/(checkouts?|account|challenge)(\/|$)/.test(location.pathname) || this.dataset.page.startsWith('customers/');
      this.state = this.read(localStorage, this.key);
      this.session = this.read(sessionStorage, this.sessionKey);
      this.active = Number(this.session.active) || 0;
      this.scrolled = !!this.session.scrolled;
      this.subscribed = this.dataset.subscribed === 'true' || !!this.state.subscribed;
      this.querySelectorAll('[data-wish-close]').forEach(button => button.addEventListener('click', () => this.dismiss(), { signal }));
      this.tab.addEventListener('click', () => this.open(), { signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, { signal });
      this.dialog.addEventListener('close', () => document.documentElement.classList.remove('fd-wish-open'), { signal });
      document.addEventListener('shopify:section:select', event => { if (event.target.contains(this)) this.open(); }, { signal });
      document.addEventListener('shopify:section:deselect', event => { if (event.target.contains(this)) this.dismiss(); }, { signal });
      window.addEventListener('storage', event => {
        if (event.key !== this.key) return;
        this.state = this.read(localStorage, this.key);
        this.subscribed = this.dataset.subscribed === 'true' || !!this.state.subscribed;
        if (this.subscribed || Date.now() - Number(this.state.dismissed) < this.cooldown()) this.dialog.close();
        this.syncTab();
      }, { signal });
      this.form.addEventListener('submit', event => {
        if (!this.ready) { event.preventDefault(); this.querySelector('[data-wish-preview]').hidden = false; return; }
        this.write(sessionStorage, '2d-wish-pending', { at: Date.now() });
      }, { signal });
      if (!this.ready) this.querySelector('[data-wish-preview]').hidden = false;
      const pending = this.read(sessionStorage, '2d-wish-pending');
      const recentlySubmitted = Date.now() - Number(pending.at) < 15 * 60 * 1000;
      if (recentlySubmitted && this.querySelector('[data-wish-success]')) {
        this.subscribed = true;
        this.state.subscribed = true;
        this.write(localStorage, this.key, this.state);
        this.write(sessionStorage, '2d-wish-pending', {});
        this.open();
        this.querySelector('[data-wish-success]').focus();
      } else if (recentlySubmitted && this.querySelector('[data-wish-errors]')) {
        this.open();
      } else if (this.preview) {
        this.open();
      }
      this.syncTab();
      this.onScroll = () => {
        const distance = document.documentElement.scrollHeight - innerHeight;
        if (distance <= 0 || scrollY / distance * 100 >= Number(this.dataset.scroll)) this.scrolled = true;
      };
      window.addEventListener('scroll', this.onScroll, { passive: true, signal });
      this.onScroll();
      this.lastTick = performance.now();
      this.timer = setInterval(() => {
        const now = performance.now();
        const elapsed = Math.min(1500, now - this.lastTick);
        this.lastTick = now;
        if (this.excluded || this.editor || !this.ready || this.subscribed || Date.now() - Number(this.session.shown || 0) < this.cooldown()) return;
        if (!document.hidden && !this.dialog.open) this.active += elapsed;
        this.session.active = this.active;
        this.session.scrolled = this.scrolled;
        this.write(sessionStorage, this.sessionKey, this.session);
        const busy = document.querySelector('dialog[open], cart-drawer[open], menu-drawer[open], search-drawer[open], cookie-banner[open], [aria-modal="true"][open]');
        const typing = /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '') || document.activeElement?.isContentEditable;
        const coolingDown = Date.now() - Number(this.state.dismissed || 0) < this.cooldown();
        if (!document.hidden && !busy && !typing && !coolingDown && this.active >= Number(this.dataset.delay) * 1000 && this.scrolled) {
          this.session.shown = Date.now();
          this.write(sessionStorage, this.sessionKey, this.session);
          this.open();
        }
      }, 1000);
    }
    read(storage, key) { try { return JSON.parse(storage.getItem(key) || '{}') || {}; } catch { return {}; } }
    write(storage, key, value) { try { storage.setItem(key, JSON.stringify(value)); } catch {} }
    cooldown() { return Number(this.dataset.cooldown) * 3600000; }
    syncTab() { this.tab.hidden = this.excluded || this.subscribed || !this.ready || this.dialog.open; }
    open() {
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.querySelector('.fd-wish__art').style.setProperty('--wish-art', `url("${this.dataset.art}")`);
      this.dialog.showModal();
      document.documentElement.classList.add('fd-wish-open');
      this.syncTab();
    }
    dismiss() {
      if (!this.preview && !this.editor) {
        this.state.dismissed = Date.now();
        this.write(localStorage, this.key, this.state);
      }
      this.dialog.close();
      if (this.preview) {
        const url = new URL(location.href);
        url.searchParams.delete('wish_preview');
        history.replaceState(null, '', url);
        this.preview = false;
      }
      this.syncTab();
      if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('fd-wish-open');
    }
  });
}
